<template>
    <div>
        <div class="c-media-gallery">
            <div class="c-media-gallery--mediawrapper">
                <div class="c-media-gallery--modaltoggle">
                    <div class="c-media-gallery--button" @click="handleModalOpen()">
                        <v-icon name="icon-minimize" size="xs"></v-icon>
                    </div>
                </div>

                <img :src="currentImage.url" :alt="currentImage.alt" />
            </div>

            <div class="c-media-gallery--caption" v-if="currentImage.caption">
                {{ currentImage.caption }}
            </div>

            <div class="c-media-gallery--thumbnails">
                <div class="c-media-gallery--thumbnail" :class="{ 'active': activeIndex === index }"
                    @click="activeIndex = index" v-for="(mediaItem, index) in listItems" :key="index">
                    <div class="c-media-gallery--thumbnailwrapper">
                        <img :src="mediaItem.thumbnail" />
                    </div>
                </div>
            </div>
            
            <div class="c-media-gallery--showmore" v-if="showPagination" @click="showAllImages = true">
                <span>{{ showMore }} ({{ itemCount }})</span>
                <span>
                    <v-icon name="icon-chevron" cssModifiers="icon"></v-icon>
                </span>
            </div>
        </div>

        <v-media-gallery-modal v-if="showModal" :items="items" :currentParentIndex="activeIndex"
            @onClose="handleModalClose"></v-media-gallery-modal>
    </div>
</template>

<script>

import VIcon from "../icon/VIcon.vue";
import VMediaGalleryModal from "./VMediaGalleryModal.vue";

export default {
    name: 'VMediaGallery',
    components: {
        VIcon,
        VMediaGalleryModal
    },
    props: {
        items: {
            type: Array,
            default: () => []
        },
        showMore: {
            type: String,
            default: "Visa alla"
        }
    },
    data: function () {
        return {
            activeIndex: 0,
            itemsToShow: 0,
            showAllImages: false,
            showModal: false
        }
    },
    computed: {
        currentImage: function () {
            return this.items[this.activeIndex];
        },
        listItems: function () {
            if (this.showAllImages) {
                return this.items;
            }

            return this.items.slice(0, this.itemsToShow);
        },
        itemCount: function () {
            return this.items.length;
        },
        showPagination: function(){
            if(this.showAllImages) return false;

            return this.itemCount > this.itemsToShow;
        }
    },
    methods: {
        handleModalOpen() {
            this.showModal = true;
        },
        handleModalClose() {
            this.showModal = false;
        },
        onWindowResize(){
            this.itemsToShow = window.innerWidth <= 720 ? 4 : 6;
        }
    },
    created() {
        this.onWindowResize();
        window.addEventListener('resize', this.onWindowResize);
    },
    destroyed() {
        window.removeEventListener('resize', this.onWindowResize);
    }   
}
</script>
